<div ng-controller="LicenseFileController as licenseFileCtrl">
    <c-auto-form config="licenseFileCtrl.autoFormConfig"></c-auto-form>
    <div class="invalid" ng-if="!licenseFileCtrl.isValid" data-translate="admin.license.invalid"></div>
</div>